import { sanitizeTags } from "@components/utils/sanitizeHelpers";
import { IAccommodationResponse, } from "@customTypes/modelResponses";
import useSliderRefresh from "@hooks/useSliderRefresh";
import ModalCard from "@libs/cards/ModalCard";
import { useMemo } from "react";
import ViewAllLayout from "./ViewAllLayout";

interface ViewAllAccommodationsLayoutProps {
  title: string;
  openViewAllAccommodations: (shouldOpen: boolean) => void;
  viewAllAccommodationsData: IAccommodationResponse[];
}

function ViewAllAccommodationsLayout({
                                       title,
                                       openViewAllAccommodations,
                                       viewAllAccommodationsData,
                                     }: ViewAllAccommodationsLayoutProps): JSX.Element {
  const { sliderRefresh, setSliderRefresh } = useSliderRefresh();
  const onExploreAllAccommodationsClick = (): void => {
    openViewAllAccommodations(false);
    if (setSliderRefresh) {
      setSliderRefresh(!sliderRefresh);
    }
  };

  const accommodationsData = useMemo(() => {
    return viewAllAccommodationsData.slice();
  }, [viewAllAccommodationsData]);

  // DESKTOP ONLY
  return (
    <ViewAllLayout
      title={"Where to stay in " + title}
      onCloseHandler={onExploreAllAccommodationsClick}
    >
      {/* Accommodation cards section */}
      {accommodationsData.map((accommodation) => (
        <div key={accommodation.id} className="w-7/8">
          <ModalCard
            id={accommodation?.id}
            title={accommodation?.Title}
            subtitle={title}
            blurb={accommodation?.Blurb}
            url={accommodation?.SEO?.Slug}
            // opensNewTab
            tags={sanitizeTags(accommodation?.tags)}
            images={accommodation?.Media?.PrimaryImage}
            imageSize={"small"}
            priceRate={accommodation?.Rate}
            tagLeftTag={{
              id: accommodation?.id,
              title: accommodation?.Property_Category,
            }}
            isHorizontal={true}
            hasLike={true}
            cardType="accommodation"
            linkTitle={`View ${accommodation?.Property_Category}`}
          />
        </div>
      ))}
    </ViewAllLayout>
  );
}

export default ViewAllAccommodationsLayout;
